import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './Login.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/request-password-reset', { email });
      setMessage('Falls ein Konto existiert, haben wir dir einen Link geschickt.');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Die Anfrage konnte nicht verarbeitet werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>🦆 Cruising Ducks</h1>
        <h2>Passwort vergessen</h2>
        {message && <div className="info-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="forgotEmail">E-Mail</label>
            <input
              type="email"
              id="forgotEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Sende Link...' : 'Reset-Link anfordern'}
          </button>
        </form>
        <p className="register-link">
          Zurück zum <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;

